import { render, staticRenderFns } from "./vina-errazuriz.vue?vue&type=template&id=23edab99&scoped=true"
import script from "./vina-errazuriz.vue?vue&type=script&lang=js"
export * from "./vina-errazuriz.vue?vue&type=script&lang=js"
import style0 from "./vina-errazuriz.vue?vue&type=style&index=0&id=23edab99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edab99",
  null
  
)

export default component.exports